import { isObject } from 'utils/helpers';

// biome-ignore lint/correctness/noUnusedImports: NavbarOptionFeatureFlagConfig is used in JSDocs documentation
import type { NavbarOptionFeatureFlag, NavbarOptionFeatureFlagConfig } from '../types/navigation';
import type { UserContextFeatureFlags } from 'core/userContext/types';
/**
 * Aggregate flags and return true if all flags are enabled
 * Keeping same logic from legacy navbar for `disabled` {@link NavbarOptionFeatureFlagConfig.disabled} property
 * src/core/userContext/selectors/selectDoesUserHaveAccessCheck
 *
 * if a linkFeatureFlag is string, return if flag is enabled,
 * if a linkFeatureFlag is an object:
 *
 * | Flag State | disabled: true | disabled: false |
 * |------------| -------------- | --------------- |
 * | Flag on    | no show        | shows           |
 * | Flag off   | shows          | no show         |
 */
export const hasFeatureFlagEnabled = (
  featureFlags: UserContextFeatureFlags,
  linkFeatureFlags: NavbarOptionFeatureFlag[] = [],
  requireOnlyOneFlag?: boolean,
) => {
  // show link if no flags
  if (!linkFeatureFlags?.length) return true;

  const getIsFeatureFlagEnabled = (flag: NavbarOptionFeatureFlag) => {
    const featureFlagName = isObject(flag) ? flag.name : flag;
    const isFeatureFlagEnabled = !!featureFlags[featureFlagName];

    if (!isObject(flag)) return isFeatureFlagEnabled;

    // Handle object flags
    return flag.disabled ? !featureFlags[featureFlagName] : isFeatureFlagEnabled;
  };

  return requireOnlyOneFlag
    ? linkFeatureFlags.some(getIsFeatureFlagEnabled)
    : linkFeatureFlags.every(getIsFeatureFlagEnabled);
};
